// extracted by mini-css-extract-plugin
export default {"content":"accordion_content__a8pq5","content-parent":"accordion_content-parent__wYEAd"};